import * as React from 'react'
import {FC} from 'react'
import {observer} from 'mobx-react'
import {useStores} from '../../../../lib/MobXProvider'
import {WidgetApi} from '../../../../lib/WidgetApi'
import {getPaymentMethodTitle} from '../../../../lib/helpers'
import {FormPart} from '../../../wrappers/FormPart'
import {RippleWrapper} from '../../../wrappers/RippleWrapper'
import {TestModeBar} from '../../../ui/TestModeBar'
import {PaymentMethodForm} from './PaymentMethodForm'
import {PaymentMethodDetailsHeaderInfo} from './PaymentMethodDetailsHeaderInfo'

///////////////////////////////////////////////////////////////////////////////

type SubscriptionPaymentMethodDetailsProps = {
  topElementId: string
}

///////////////////////////////////////////////////////////////////////////////

export const SubscriptionPaymentMethodDetails: FC<SubscriptionPaymentMethodDetailsProps> = observer(
  (props) => {
    const {api} = useStores<{api: WidgetApi}>()
    const {uiTransitionTimeout: timeout} = api.computedConfig
    const {topElementId} = props
    let form

    if (api.subscriptionInfo) {
      form = api.subscriptionRenewForm
    }

    if (api.epmsSubscriptionInfo) {
      form = api.paymentForm
    }

    const paymentMethod = form.getPaymentMethod()
    const paymentMethodTitle = getPaymentMethodTitle(
      paymentMethod,
      api.subscriptionRenewForm,
      api.trans.bind(api),
    )

    const cancelPaymentMethodSelection = () => {
      setTimeout(async () => {
        form.setLastSelectedPaymentMethod(paymentMethod)
        form.setPaymentMethod(null)
        await api.ui.scrollTo('#' + topElementId)
      }, timeout)
    }
    const submit = () => form.validateAndSend()

    return (
      <div className="subscription-payment-method-details">
        <div className="main">
          <section className="payment-method-details">
            <div className="header">
              <div className="title" aria-live="assertive">
                <h2 className="text">{paymentMethodTitle}</h2>
              </div>
              <PaymentMethodDetailsHeaderInfo form={form} />
            </div>

            <FormPart className="main" onSubmit={submit}>
              <fieldset
                id={api.ui.generateUniqueElementId('payment-method-form')}
              >
                <legend>
                  {api.trans(
                    'blocks.subscription_payment_method_update.payment_method_details.legend',
                  )}
                </legend>

                <PaymentMethodForm form={form} />
              </fieldset>
            </FormPart>
          </section>
        </div>

        <TestModeBar />

        <div className="actions">
          <RippleWrapper>
            <button
              type="button"
              className="btn btn-primary action-save"
              onClick={submit}
            >
              <span className="btn-text">
                {api.trans(
                  'blocks.subscription_payment_method_update.payment_method_details.save',
                )}
              </span>
            </button>
          </RippleWrapper>

          <RippleWrapper>
            <button
              type="button"
              className="btn action-back"
              onClick={cancelPaymentMethodSelection}
            >
              <span className="btn-text">
                {api.trans(
                  'blocks.subscription_payment_method_update.payment_method_details.cancel',
                )}
              </span>
            </button>
          </RippleWrapper>
        </div>
      </div>
    )
  },
)
